<template>
	<div class="landing" v-bar ref="scrollBar">
		<div class="landing-scroll-cnt" @scroll="onScroll" @mousewheel="onMouseWheel"  ref="scrollContainer">
			<!--<index v-if="Helpers.isTouch()"></index>-->
			<div class="landing-bg">
				<Rules id="Rules"></Rules>
				<Test id="Test" :canAnimate="canAnimate"></Test>
			</div>
			<VideoComponent id="Video" :canAnimate2="canAnimate2"></VideoComponent>
			<Product id="Product" :canAnimate3="canAnimate3"></Product>
		</div>
	</div>
</template>


<script>

	import Rules from './Rules'
	import Test from './Test'
	import VideoComponent from './Video'
	import Product from './Product'
	import Index from './Index.vue'

	import Helpers from '@/tools/Helpers'

	export default {
		name: 'Landing',
		components: {
			Rules,
			Test,
			VideoComponent,
			Product,
            Index,
			Helpers
		},
		data() {
			return {
				Helpers,
				canTween: true,
				canAnimate: false,
				canAnimate2: false,
				canAnimate3: false
			}
		},
		watch: {
			'$route.name'(name) {
				if (this.canTween) {
					this.tweenToPage(name);
				}
			}
		},
		computed: {
			routName() {
				return this.$route.name;
			}
		},
		methods: {
			onScroll(e) {
				const els = [
					document.getElementById('Rules'),
					document.getElementById('Test'),
					document.getElementById('Video'),
					document.getElementById('Product'),
				];

				let nodes = els.filter((item) => {
					return this.isInViewport(item);
				});


				let delta = e.deltaY || e.detail || e.wheelDelta;
                let container = this.$refs['scrollContainer'];

				if(container.scrollTop === 0 && container.scrollTop < this.lastScrollTop){
					if(els[0].getBoundingClientRect().top >= 0){
						this.$router.push({name: 'Index'});
					}
					return;
				}

				this.setActive(nodes, delta);

				this.lastScrollTop = container.scrollTop;
			},
			onMouseWheel(e) {
				let delta = e.deltaY || e.detail || e.wheelDelta;

				const els = [
					document.getElementById('Rules'),
					document.getElementById('Test'),
					document.getElementById('Video'),
					document.getElementById('Product'),
				];


				let nodes = els.filter((item) => {
					return this.isRect(item);
				});


				if(document.getElementById('Test').getBoundingClientRect().top <= 450){
					this.canAnimate = true;
				}
				if(document.getElementById('Video').getBoundingClientRect().top <= 250){
					this.canAnimate2 = true;
				}
				if(document.getElementById('Product').getBoundingClientRect().top <= 250){
					this.canAnimate3 = true;
				}
			},

			isRect(el){
				let rect = el.getBoundingClientRect();
				return rect.top <= 200;
			},

			isInViewport(el) {
				let rect = el.getBoundingClientRect();
				let html = document.documentElement;
				return rect.top <= 0;
			},
			setActive(items) {
				if (items.length) {
					this.canTween = false;
					let path = items[items.length - 1].id;
					this.$router.push({name: path});

					this.$nextTick(() => {
						if(path === 'Video'){
							this.canAnimate2 = true;
						}
						if(path === 'Test'){
							this.canAnimate = true;
						}
						if(path === 'Product'){
							this.canAnimate3 = true;
						}
						this.canTween = true;
					})
				}
			},

			tweenToPage(name) {
				let self = this;
				let container = this.$refs['scrollContainer'];
				let rect = document.getElementById(name).getBoundingClientRect();

				this.canTween = false;

				TweenMax.to(container, .5, {
					scrollTop: container.scrollTop + rect.top + 1
				});

			}
		},
		mounted() {
//			this.$vuebar.destroyScrollbar(this.$refs['scrollBar']);
			this.$store.commit('UPD_UI_SHOW', true);
			this.canTween = true;
			setTimeout(()=>{
                this.tweenToPage(this.routName);
			});
		}

	}
</script>



// WEBPACK FOOTER //
// landing.vue?5161967c